import { Avatar, Box, Checkbox, Grid, Typography, useMediaQuery, useTheme } from '@mui/material'
import React from 'react'
import stylesLogo from '../Accounts/Account.styles';
import sizeFontCustom from "../Discovery/fontSize.styles"
import { useTranslation } from '../../hooks/useTranslation';

function FrequentFip(props) {
  const { t } = useTranslation();
  const { fipId, popular, handleCheckboxChange, selectedFipList } = props;
  const theme = useTheme();
  const mobileScreen = useMediaQuery(theme.breakpoints.down("md"));
  
  // Check for dark theme
  const isDark = props.customDetails?.darkTheme === true || theme.palette.mode === 'dark';
  return (
    <Grid
      item
      
      xs={5.75}
      sm={5.75}
      md={5.75}
      lg={2.75}
      padding={mobileScreen ? "0.75rem" : popular ? "1rem 1.25rem" : "1rem 1rem"}
      // margin={"0 0 0 0"}
      sx={{
        display: mobileScreen ? "flex" : "block",
        justifyContent: "space-between",
        alignItems: "center",
        background: isDark ? '#161616' : theme.palette.primary.white,
        color: isDark ? '#FFFFFF' : '#000000',
        borderRadius: "20px",
        border: isDark ? '1px solid #7A8185' : 'none',
        transition: 'all 0.2s ease-in-out',
        '&:hover': {
          background: isDark ? '#3D3D3D' : '#F5F5F5',
          transform: 'translateY(-2px)',
          boxShadow: isDark ? '0 4px 8px rgba(0,0,0,0.3)' : '0 4px 8px rgba(0,0,0,0.1)',
        },
      }}
    >
      <Box  onClick={(e) => handleCheckboxChange(e, fipId)} display={"flex"} justifyContent={"space-between"} alignItems={"center"} width={"100%"}>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Avatar alt={fipId} src={global.objectFormatFip[fipId]?.productIconUri} sx={stylesLogo.avatarStyle} />
          <Typography sx={{
            ...sizeFontCustom.subHeading,
            color: isDark ? '#FFFFFF' : 'inherit'
          }} textAlign={"start"}>
            {t(`fips.${global.objectFormatFip[fipId]?.fipId}`)}
          </Typography>
        </Box>
        <Checkbox
          disableTouchRipple
          disableRipple
          name={fipId}
          value={fipId}
          size={mobileScreen ? "small" : popular ? "medium" : "small"}
          sx={{ 
            height: "18px", 
            width: "18px", 
            ml: "0.675rem",
            color: isDark ? '#7A8185' : '#D8E1EE',
            '&.Mui-checked': {
              color: props.customDetails?.primaryColor || '#3053D3',
            },
            '&:hover': {
              backgroundColor: isDark ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.04)',
            },
          }}
          checked={selectedFipList.includes(fipId)}
          onChange={(e) => handleCheckboxChange(e, fipId)}
        />
      </Box>
    </Grid>
  )
}

export default FrequentFip